import classnames from "classnames";
import Image from "next/legacy/image";
import { useMatchMedia } from "@/hooks";
import styles from "@/styles/Channel.module.scss";

export default function ChannelHeroImage({ channel }) {
  if (!channel) return null;
  const largeSize = useMatchMedia(
    [{ query: "screen and (min-width: 640px)", value: true }],
    false
  );
  // pc 1600 320
  // mb 1280 600
  // media query 640で切り替え
  return (
    <div className={classnames(styles.hero, { [styles.large]: largeSize })}>
      <div className={styles.inner}>
        <div className={styles.pc}>
          {channel?.heroImage?.pc && (
            <Image
              src={channel.heroImage.pc}
              alt={channel.name}
              width={1600}
              height={320}
              layout="responsive"
            />
          )}
        </div>
        <div className={styles.mb}>
          {channel?.heroImage?.mb && (
            <Image
              src={channel.heroImage.mb}
              alt={channel.name}
              width={1280}
              height={600}
              layout="responsive"
            />
          )}
        </div>
      </div>
    </div>
  );
}
